
import TencentCaptcha from 'TencentCaptcha';
import {
	Component,
	Vue
} from 'vue-property-decorator';
import {
	doLogin,
	getUserInfo,
	authsendSmsCode,
	authreSetLoginPassword,
	authvaliteProviderPhone
} from '@/api/user'
import { MallKey } from "@/utils/config"
import {
	setUserInfo,
	setUserId,
	removeUserId,
	removeUserInfo
} from '@/utils/storage'
import store from '@/store';

@Component({
	name: 'login-index'
})
export default class Login extends Vue {
	private MallKey = MallKey
	private account = '';
	private password = '';
	private againpassword = ''
	private validation = ''
	private emptyAccountText = ''
	private emptyPasswordText = ''
	private emptyagainPasswordText = ''
	private emptyvalidationText = ''
	private validationShow = false
	private isChangePsd = false
	private smgShow = false
	private countdown: any = ''
	private countdown2: any = ''
	private num = 60
	private num2 = 60
	private type = 1
	private captcha1: any = {}

	private mounted() {
		this.$nextTick(() => {

			/* eslint-disable */
			// eslint-disable-next-line no-undef
			this.captcha1 = new TencentCaptcha('2017604677', this.validationcallback, { //eslint-disable-line
				needFeedBack: false,
			});
			/* eslint-enable */
		})
	}

	private forget() {
		this.password = ''
		this.validation = ''
		this.againpassword = ''
		this.emptyAccountText = ''
		this.emptyPasswordText = ''
		this.emptyagainPasswordText = ''
		this.emptyvalidationText = ''
		this.isChangePsd = true
	}
	private async changepsd() {
		this.emptyAccountText = ''
		this.emptyPasswordText = ''
		this.emptyagainPasswordText = ''
		this.emptyvalidationText = ''
		if (!this.account) {
			this.emptyAccountText = '请输入账号'
			return
		} else if (!this.password || this.password.length < 6) {
			this.emptyPasswordText = '请设置不低于6位数的密码'
			return
		} else if (this.password.length > 20) {
			this.emptyPasswordText = '请设置最多20位数的密码'
			return
		} else if (this.password != this.againpassword) {
			this.emptyPasswordText = '两次输入的密码不一致，请确认后重试'
			return
		}
		else if (!this.validation) {
			this.emptyvalidationText = '验证码不能为空'
			return
		}
		//  
		else if (this.emptyAccountText || this.emptyPasswordText || this.emptyagainPasswordText || this.emptyvalidationText) {
			return
		}
		try {
			let res = await authreSetLoginPassword({
				MallKey: this.MallKey,
				Password: this.password,
				Account: this.account,
				Code: this.validation
			})
			if (res.IsSuccess) {
				this.$message.success('修改成功，请使用新密码登录')
				setTimeout(() => {
					removeUserId();
					removeUserInfo();
					location.reload()
				}, 2000)
			}
		} finally {
			//
		}
	}
	private checklogin(e) {
		this.type = e
		if (!this.account) {
			this.emptyAccountText = '请输入正确的手机号'
			return
		}
		this.captcha1.show(); // 显示验证码
	}
	//发送短信验证码
	private async validationcallback(e) {
		try {
			let valite = await authvaliteProviderPhone({
				MallKey: this.MallKey,
				Account: this.account
			})
			if (!valite.IsSuccess) {
				return
			}
			// console.log(e)
			if (e.ret == 0) {
				let res = await authsendSmsCode({
					MallKey: this.MallKey,
					Account: this.account,
					Type: this.isChangePsd ? 7 : 3,
					Ticket: e.ticket,
					Randstr: e.randstr,
					FromType: 1
				})
				// console.log(res)
				if (res.IsSuccess) {
					this.$message.success('已发送验证码')
					if (this.type == 1) {
						this.countdown = setInterval(() => {
							if (this.num > 1) {
								this.num--
							} else {
								clearInterval(this.countdown)
								this.num = 60
							}
						}, 1000)
					} else {
						this.countdown2 = setInterval(() => {
							if (this.num2 > 1) {
								this.num2--
							} else {
								clearInterval(this.countdown2)
								this.num2 = 60
							}
						}, 1000)
					}
				}
			}
		} finally {
			//
		}
	}
	/**
	 * 登录
	 */
	private async handleLogin() {
		this.emptyAccountText = ''
		this.emptyPasswordText = ''
		this.emptyvalidationText = ''
		if (!this.account) {
			this.emptyAccountText = '账号不能为空'
			return
		} else if (!this.password) {
			this.emptyPasswordText = '密码不能为空'
			return
		} else if (this.emptyAccountText || this.emptyPasswordText) {
			return;
		}
		try {
			const res: any = await doLogin({
				Password: this.password,
				Account: this.account,
				MallKey: "routuan",
				Code: this.validation
			});
			if (res.IsSuccess) {
				setUserId(1);
				setUserInfo(res.Result)
				await store.dispatch('setContractType')
				this.$router.push({
					path: '/'
				})
			}
		} catch (e) {
			// this.emptyAccountText = '您的账号密码有误，请重新输入'
			// this.emptyPasswordText = '您的账号密码有误，请重新输入'
			// console.error('doLogin ===>', e);
		}
	}

	/**
	 * 获取用户信息
	 */
	private async getUserInfo(id: number) {
		try {
			const res: any = await getUserInfo({
				user_id: id
			});
			setUserInfo(res.info);
			await this.$router.push({
				path: '/'
			})
		} catch (e) {
			console.log('userInfo ===>', e)
		}
	}
}
